import { gql, type Variables } from 'graphql-request'

import { client } from '@/proxy/client'
import { useMutation, useQueryClient } from '@/proxy/react-query'
import { SELLER_INFO_KEY } from '@/proxy/seller/hooks/useSellerInfo'
import type { MutationDataError } from '@/resources/types'
import type {
  SaveOrderEditingTutorialDataMutationData,
  SaveOrderEditingTutorialDataMutationVariables,
} from './types'

export const SAVE_ORDER_EDITING_TUTORIAL_DATA = gql`
  mutation saveOrderEditingTutorialData(
    $input: SaveOrderEditingTutorialDataInput!
  ) {
    saveOrderEditingTutorialData(input: $input) {
      ok
      errors {
        key
        message
      }
    }
  }
`

export const useSaveOrderEditingTutorialData = () => {
  const queryClient = useQueryClient()

  return useMutation<
    SaveOrderEditingTutorialDataMutationData,
    MutationDataError,
    SaveOrderEditingTutorialDataMutationVariables
  >({
    mutationFn: variables =>
      client.request<SaveOrderEditingTutorialDataMutationData>(
        SAVE_ORDER_EDITING_TUTORIAL_DATA,
        variables as unknown as Variables
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [SELLER_INFO_KEY] })
    },
  })
}
